<template>
  <div class="line-item">
    <img
      v-if="sizedImageSrc"
      :src="sizedImageSrc"
      :alt="imageAlt"
      class="line-item-image"
    />
    <span v-if="flashMessage" class="line-item-text line-item-flash-message">
      {{ flashMessage }}
    </span>
    <a
      v-else
      :href="url"
      :tabindex="isFocusable === false ? -1 : 0"
      class="line-item-text"
    >
      <h4 class="line-item-title">{{ title }}</h4>
      <span class="line-item-subtitle">{{ subtitle }}</span>
      <span v-if="subscriptionText.length > 0" class="line-item-subtitle">
        {{ subscriptionText }}
      </span>
      <span class="line-item-price">{{ price }}</span>
      <span v-if="comparePrice.length > 0" class="line-item-price-compare">
        {{ comparePrice }}
      </span>
    </a>
    <div class="line-item-cta">
      <div class="custom-select">
        <select
          v-model="currentQuantity"
          :tabindex="isFocusable === false ? -1 : 0"
        >
          <option value="0">{{ removeLabel }}</option>
          <option
            v-for="n in currentQuantity + 10"
            :key="n + title"
            :data-thing="n + title"
            :value="n"
          >
            {{ n * multiplier }}
          </option>
        </select>
        <svg class="icon icon-cheveron-down">
          <use xlink:href="#icon-cheveron-down" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import * as ShopifyImage from '@shopify/theme-images';

import { mapMutations } from 'vuex';
import { flyoutCart, mutations } from './store';

export default {
  name: 'LineItem',
  props: {
    comparePrice: {
      default: '',
      type: String
    },
    imageAlt: {
      default: '',
      type: String
    },
    variantId: {
      type: Number,
      required: true
    },
    imageSrc: {
      default: '',
      type: String
    },
    isFocusable: {
      default: false,
      type: Boolean
    },
    multiplier: {
      default: 1,
      type: Number
    },
    price: {
      default: '',
      type: String
    },
    properties: {
      type: Object,
      default: () => {}
    },
    quantity: {
      default: 1,
      type: Number
    },
    removeLabel: {
      default: '',
      type: String
    },
    sellingPlanAllocation: {
      type: Object
    },
    subtitle: {
      default: '',
      type: String
    },
    subscriptionLabel: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    url: {
      default: '/',
      type: String
    },
    flashMessage: {
      default: '',
      type: String
    }
  },

  computed: {
    currentQuantity: {
      get() {
        return this.quantity;
      },
      set(newVal) {
        const value = parseInt(newVal);

        if (value === 0) {
          this.$emit('remove');
        } else {
          this.$emit('update', value);
        }
      }
    },

    sizedImageSrc() {
      try {
        return ShopifyImage.getSizedImageUrl(this.imageSrc, '58x');
      } catch (err) {
        console.error(err);

        return false;
      }
    },

    subscriptionText() {
      if (__SHOPIFY_SUBSCRIPTIONS__ && this.sellingPlanAllocation) {
        // If Shopify Subscriptions are enabled we can just show the selling plan name
        const { selling_plan: sellingPlan } = this.sellingPlanAllocation;

        return sellingPlan.name;
      } else if (!__SHOPIFY_SUBSCRIPTIONS__) {
        if (
          this.properties &&
          this.properties.shipping_interval_unit_type &&
          this.properties.shipping_interval_frequency
        ) {
          return `${this.subscriptionLabel}: ${this.properties.shipping_interval_frequency} ${this.properties.shipping_interval_unit_type}`;
        }
        return '';
      }

      return '';
    }
  },

  watch: {
    flashMessage: function(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.clearFlashMessage({ id: this.variantId });
        }, 2000);
      }
    }
  },

  methods: {
    ...mapMutations({
      clearFlashMessage: `${flyoutCart}/${mutations.CLEAR_FLASH_MESSAGE}`
    })
  }
};
</script>
